import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["monthlyButton", "yearlyButton", "monthlyForm", "yearlyForm",
                    "monthlyPlanTier", "yearlyPlanTier"]

  selectMonthly() {
    // Update button styles
    this.monthlyButtonTarget.classList.add("bg-blue-600", "text-white")
    this.monthlyButtonTarget.classList.remove("text-gray-600", "hover:text-gray-900")
    this.yearlyButtonTarget.classList.remove("bg-green-600", "text-white")
    this.yearlyButtonTarget.classList.add("text-gray-600", "hover:text-gray-900")

    // Show monthly form, hide yearly form
    this.monthlyFormTarget.classList.remove("hidden")
    this.yearlyFormTarget.classList.add("hidden")
  }

  selectYearly() {
    // Update button styles
    this.yearlyButtonTarget.classList.add("bg-green-600", "text-white")
    this.yearlyButtonTarget.classList.remove("text-gray-600", "hover:text-gray-900")
    this.monthlyButtonTarget.classList.remove("bg-blue-600", "text-white")
    this.monthlyButtonTarget.classList.add("text-gray-600", "hover:text-gray-900")

    // Show yearly form, hide monthly form
    this.yearlyFormTarget.classList.remove("hidden")
    this.monthlyFormTarget.classList.add("hidden")
  }
}
